import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import type { DialogProps } from '@mui/material';
import { TRASH_RESTORE_ID } from '@const';
import { DriveDto } from '@dto/DriveDto';
import { useAlert, useProgress } from '@hook';
import { driveApi } from '@api';

/**
 * onProcess => 처리 시작, 처리 중
 * onCreated => 처리 완료
 * onFailed => 처리 실패
 */
type TrashRestoreModalProps = DialogProps & {
  selected?: DriveDto[];
  onCreated: (id: string, result?: any) => void;
  onCancel: (id: string) => void;
  onFailed?: (id: string) => void;
  onProcess?: (id: string) => void;
};

export const TrashRestoreModal: React.FC<TrashRestoreModalProps> = (props) => {
  const { selected, onCreated, onCancel, onProcess, ...other } = props;
  const { progressOpen, progressClose } = useProgress();
  const { alertOpen } = useAlert();

  const handleOk = async () => {
    try {
      progressOpen(
        '휴지통',
        '파일을 복원하고 있습니다.'
      );

      if (!selected || selected.length === 0) {
        throw new Error('선택된 파일 혹은 디렉토리가 없습니다.');
      }

      await Promise.all(
        selected.map(async (value) => await driveApi.move([`${value.path}`], 'trash', '', value.driveType))
      );
      onCreated(TRASH_RESTORE_ID);
    } catch (error: any) {
      alertOpen({
        title: '오류',
        content: (<Box>
          휴지통으로 이동 중 오류가 발생했습니다.<br />
          {error.message}
        </Box>),
        onOk () {
          onCancel(TRASH_RESTORE_ID);
        }
      });
    } finally {
      progressClose();
    }
  };

  const handleCancel = () => {
    onCancel(TRASH_RESTORE_ID);
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={'xs'}
        {...other}>
        <DialogTitle>휴지통</DialogTitle>
        <DialogContent>
          <DialogContentText>
            선택하신 항목을 복원하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="inherit"
            onClick={handleCancel}
          >
            취소
          </Button>
          <Button
            color="secondary"
            onClick={handleOk}
          >
            복원
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
};
